import { get, post } from "../api/apiClient";
import { authHeader } from "../api/authHeader";
import EvaluationListUpdateRequest from "../form/request/EvaluationListUpdateRequest";

const API_PREFIX = "/evaluationList";

export const init = async () => {
  const response = await get(`${API_PREFIX}/`, authHeader());
  console.log("response", response);
  return response.data;
};

export const update = async params => {
  const response = await post(`${API_PREFIX}/update`, new EvaluationListUpdateRequest(params), authHeader());
  console.log("response", response);
  return response.data;
};
